// extracted by mini-css-extract-plugin
export var drawerPaper = "_29-0";
export var itemImage = "_29-1";